
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Clientes from '@lib/Clientes'
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: Clientes.Condiciones } )
        public value: Clientes.Condiciones;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
        }

        constructor() {
            super();
        }

        public items: Array<Clientes.Condiciones> = Clientes.Condiciones.Options;


        public selected: Clientes.Condiciones | null = null;
        public get Selected(): Clientes.Condiciones | null {
            return this.selected;
        }
        public set Selected( x: Clientes.Condiciones | null ) {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }
    }
